import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_SERBIA_Cylindercentre_07 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_07.webp'
import { useEffect } from 'react';
import CenterStage from '../../../Components/CenterStage/CenterStage';
import imgHANSA_FLEX_STARTOFCYLINDERCENTRE from '../../../assets/Journey/HANSA_FLEX_STARTOFCYLINDERCENTRE.webp'
import imgHANSA_FLEX_SERBIA_Cylindercentre_01 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_01.webp'
import imgHANSA_FLEX_SERBIA_Cylindercentre_02 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_02.webp'
import imgHANSA_FLEX_SERBIA_Cylindercentre_03 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_03.webp'
import imgHANSA_FLEX_SERBIA_Cylindercentre_04 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_04.webp'
import imgHANSA_FLEX_SERBIA_Cylindercentre_05 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_05.webp'
import imgHANSA_FLEX_SERBIA_Cylindercentre_06 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_06.webp'

const Branch10 = () => {
  const data1 = {
    image: imgHANSA_FLEX_SERBIA_Cylindercentre_07,
    title: "Hydraulic cylinder",
    description: "Hydraulic cylinders perform extremely heavy work. As the most important drive elements in hydraulics, they convert the pressure energy of the hydraulic fluid into mechanical energy. Cylinders can transmit very high forces while producing uniform and precise movements. HANSA-FLEX sells a wide range of single- and to double-acting standard cylinders and manufactures customised hydraulic cylinders up to 8,000 mm in height.",
    buttonName: "Learn More",
    buttonLink: "/cylinder",
  }
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);

  const carouselData = [
    {
      image: imgHANSA_FLEX_SERBIA_Cylindercentre_01,
    },
    {
      image: imgHANSA_FLEX_SERBIA_Cylindercentre_02,
    },
    {
      image: imgHANSA_FLEX_SERBIA_Cylindercentre_03,
    },
    {
      image: imgHANSA_FLEX_SERBIA_Cylindercentre_04,
    },
    {
      image: imgHANSA_FLEX_SERBIA_Cylindercentre_05,
    },
    {
      image: imgHANSA_FLEX_SERBIA_Cylindercentre_06,
    },
  ]
  return (
    <div>
      <CenterStage imageSrc={imgHANSA_FLEX_STARTOFCYLINDERCENTRE} title={"Welcome to HANSA-FLEX Cylinder Center"} paragraph={"Cylinder Center was opened in 2019 in the Zemun branch. With dedicated and skillfull staff, it can handle any cylinder you bring us using precise machining equpment and original HANSA-FLEX elements so you can continue your work in no time."}
        buttonName={"Contact us"} buttonLink={"/contact-us"}
      />
      <ThreeDImageCarousel items={carouselData} />
      
      <div className="text-center div-gray">
        <SectionHeader
          title={"📞 At Your Service – We're Just a Call Away!"}
          subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
        />
        <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
        <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
        <br /><br /><br />
      </div>



    </div>
  )
}

export default Branch10